<template>
  <LayeredCharacter>
    <template #default="props">
      <img
        v-for="item in appliedItems"
        :key="item.id"
        :class="props.imgClass"
        :src="getLayerImageSrc(item)"
        :style="computeLayerStyle(item)"
      />
    </template>
  </LayeredCharacter>
</template>

<script>
import LayeredCharacter from './LayeredCharacter'
import { mapGetters } from 'vuex'

export default {
  components: {
    LayeredCharacter,
  },
  computed: {
    appliedItems () {
      return this.purchasedItems.filter((item) => {
        return item.purchases.some((purchase) => purchase.apply)
      })
    },
    ...mapGetters('shop', {
      purchasedItems: 'purchasedItems',
    }),
  },
  methods: {
    getLayerImageSrc (item) {
      const { image } = item
      return require(`!file-loader!@/assets/item/${image}`)
    },
    computeLayerStyle (item) {
      const { z_index } = item
      return {
        'z-index': z_index,
      }
    },
  },
}
</script>
